import React, { forwardRef } from 'react'

const TimePicker = forwardRef((props, ref) => {
    const {
        className = '',
        disabled = false,
        minuteStep = 1,
        name = 'time',
        onBlur,
        onChange,
        onFocus,
        value,
        ...rest
    } = props

    const isValidDate = value instanceof Date && !Number.isNaN(value.getTime())

    const inputValue = isValidDate
        ? `${String(value.getHours()).padStart(2, '0')}:${String(
              value.getMinutes()
          ).padStart(2, '0')}`
        : typeof value === 'string'
        ? value
        : ''

    const handleChange = (event) => {
        const time = event.target.value

        if (!time) {
            onChange?.(null)
            return
        }

        const [hours, minutes] = time.split(':').map(Number)

        const nextValue = isValidDate ? new Date(value) : new Date()

        nextValue.setHours(hours, minutes, 0, 0)

        onChange?.(nextValue)
    }

    return (
        <input
            ref={ref}
            type="time"
            name={name}
            value={inputValue}
            step={Math.max(Number(minuteStep) || 1, 1) * 60}
            disabled={disabled}
            onChange={handleChange}
            onBlur={onBlur}
            onFocus={onFocus}
            className={`
                input input-md w-full
                disabled:cursor-not-allowed
                disabled:bg-gray-100
                ${className}
            `}
            {...rest}
        />
    )
})

TimePicker.displayName = 'TimePicker'

export default TimePicker
